import {
  collection as externalActivityConfigurationInfoCollection,
  schema as externalActivityConfigurationInfoSchema,
  fetch as externalActivityConfigurationInfo,
} from './externalActivityConfigurationInfo'

export * as EXTERNAL_ACTIVITY_INFOS from './externalActivityInfo'

export const EXTERNAL_ACTIVITY_CONFIGURATION_INFO = {
  collection: externalActivityConfigurationInfoCollection,
  schema: externalActivityConfigurationInfoSchema,
  fetch: externalActivityConfigurationInfo,
}
